// =============================================================================
// app/src/lib/rotulos.ts — o nome de balcão dos enums do banco.
//
// O banco guarda 'a_ver', 'mercadolivre', 'balcao'. São ótimos nomes de coluna
// e péssimos rótulos de tela: num filtro, "a_ver" e "mercadolivre" aparecem
// crus, com underline e sem acento, e quem lê tem que traduzir de cabeça.
//
// As listas também fixam a ORDEM em que as opções aparecem, e ela não é
// alfabética de propósito: é a ordem de frequência no balcão — dinheiro e pix
// primeiro, porque são a esmagadora maioria e ficam no alcance do polegar.
//
// Espelha os enums de core/types.ts (PaymentMethod, SaleChannel). Enum novo lá,
// rótulo novo aqui — o `Record` completo faz o TypeScript cobrar isso.
// =============================================================================

import type { PaymentMethod, SaleChannel } from '@core/types';

export const ROTULO_DA_FORMA: Record<PaymentMethod, string> = {
  dinheiro: 'Dinheiro',
  pix: 'Pix',
  debito: 'Débito',
  credito: 'Crédito',
  boleto: 'Boleto',
  transferencia: 'Transferência',
  fiado: 'Fiado',
  a_ver: 'Nota "a ver"',
  // 075: o pagamento DIVIDIDO. É rótulo de venda (as partes moram em
  // sale_payments) — nenhuma tela o oferece como forma de PAGAR.
  misto: 'Misto',
};

/** Na ordem do balcão, não na do alfabeto. É a lista do FILTRO da tela de
 *  Vendas — por isso 'misto' entra (achar as vendas divididas é pergunta
 *  legítima), embora ninguém pague "em misto". */
export const FORMAS_DE_PAGAMENTO: readonly PaymentMethod[] = [
  'dinheiro', 'pix', 'debito', 'credito', 'fiado', 'a_ver', 'boleto', 'transferencia',
  'misto',
];

export const ROTULO_DO_CANAL: Record<SaleChannel, string> = {
  balcao: 'Balcão',
  whatsapp: 'WhatsApp',
  mercadolivre: 'Mercado Livre',
  amazon: 'Amazon',
  b2b: 'Parceiro B2B',
};

export const CANAIS_DE_VENDA: readonly SaleChannel[] = [
  'balcao', 'whatsapp', 'b2b', 'mercadolivre', 'amazon',
];

// OS DOIS RÓTULOS ACEITAM `string`, e não só o enum, de propósito: algumas
// consultas tipam a coluna como texto puro (VendaDetalhada.canal), e um valor
// que o app ainda não conhece — canal novo criado por migração antes de
// core/types.ts alcançá-lo — precisa virar traço na tela, não quebrar a linha.
// Forma nula também existe no histórico antigo.

export const rotuloDaForma = (f: PaymentMethod | string | null | undefined): string =>
  (f ? ROTULO_DA_FORMA[f as PaymentMethod] : null) ?? '—';

export const rotuloDoCanalDeVenda = (c: SaleChannel | string | null | undefined): string =>
  (c ? ROTULO_DO_CANAL[c as SaleChannel] : null) ?? '—';
